/**
 * Iyarkai Kudil Theme Interactive Logic
 */

document.addEventListener('DOMContentLoaded', () => {
  // --- 0. Multi-Content Announcement Bar Slider ---
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    const slides = announcementBar.querySelectorAll('.announcement-bar__slide');
    const prevBtn = announcementBar.querySelector('.announcement-bar__prev');
    const nextBtn = announcementBar.querySelector('.announcement-bar__next');
    const autoRotate = announcementBar.dataset.autoRotate === 'true';
    const speed = parseInt(announcementBar.dataset.speed, 10) || 5000;

    let currentIndex = 0;
    let timer = null;

    const showSlide = (index) => {
      slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      currentIndex = index;
    };

    const nextSlide = () => {
      const nextIndex = (currentIndex + 1) % slides.length;
      showSlide(nextIndex);
    };

    const prevSlide = () => {
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      showSlide(prevIndex);
    };

    if (slides.length > 1) {
      if (prevBtn) prevBtn.addEventListener('click', () => { prevSlide(); resetTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { nextSlide(); resetTimer(); });

      const startTimer = () => {
        if (autoRotate && !timer) {
          timer = setInterval(nextSlide, speed);
        }
      };

      const stopTimer = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };

      const resetTimer = () => {
        stopTimer();
        startTimer();
      };

      startTimer();

      announcementBar.addEventListener('mouseenter', stopTimer);
      announcementBar.addEventListener('mouseleave', startTimer);
    }
  }

  // --- 0.1 Hero Banner Full Slider ---
  const heroBanner = document.querySelector('.hero-banner-full');
  if (heroBanner) {
    const heroSlides = heroBanner.querySelectorAll('.hero-banner-full__slide');
    const heroDots = heroBanner.querySelectorAll('.hero-banner-full__dots .dot');
    const prevBtn = heroBanner.querySelector('.hero-slider-prev');
    const nextBtn = heroBanner.querySelector('.hero-slider-next');
    const autoRotate = heroBanner.dataset.autoRotate === 'true';
    const speed = parseInt(heroBanner.dataset.speed, 10) || 5000;

    let currentHeroIndex = 0;
    let heroTimer = null;

    const showHeroSlide = (index) => {
      heroSlides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      heroDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      currentHeroIndex = index;
    };

    const nextHeroSlide = () => {
      const nextIndex = (currentHeroIndex + 1) % heroSlides.length;
      showHeroSlide(nextIndex);
    };

    const prevHeroSlide = () => {
      const prevIndex = (currentHeroIndex - 1 + heroSlides.length) % heroSlides.length;
      showHeroSlide(prevIndex);
    };

    if (heroSlides.length > 1) {
      if (prevBtn) prevBtn.addEventListener('click', () => { prevHeroSlide(); resetHeroTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { nextHeroSlide(); resetHeroTimer(); });

      heroDots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          showHeroSlide(i);
          resetHeroTimer();
        });
      });

      const startHeroTimer = () => {
        if (autoRotate && !heroTimer) {
          heroTimer = setInterval(nextHeroSlide, speed);
        }
      };

      const stopHeroTimer = () => {
        if (heroTimer) {
          clearInterval(heroTimer);
          heroTimer = null;
        }
      };

      const resetHeroTimer = () => {
        stopHeroTimer();
        startHeroTimer();
      };

      startHeroTimer();

      heroBanner.addEventListener('mouseenter', stopHeroTimer);
      heroBanner.addEventListener('mouseleave', startHeroTimer);
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      const dotsWrap = heroBanner.querySelector('.hero-banner-full__dots');
      if (dotsWrap) dotsWrap.style.display = 'none';
    }
  }

  // --- 0.2 Panorama Banner Slider ---
  const panoramaBanner = document.querySelector('.panorama-banner-section');
  if (panoramaBanner) {
    const panoramaSlides = panoramaBanner.querySelectorAll('.panorama-banner-slide');
    const panoramaDots = panoramaBanner.querySelectorAll('.panorama-slider-dots .dot');
    const prevBtn = panoramaBanner.querySelector('.panorama-slider-prev');
    const nextBtn = panoramaBanner.querySelector('.panorama-slider-next');
    const autoRotate = panoramaBanner.dataset.autoRotate === 'true';
    const speed = parseInt(panoramaBanner.dataset.speed, 10) || 5000;

    let currentPanoramaIndex = 0;
    let panoramaTimer = null;

    const showPanoramaSlide = (index) => {
      panoramaSlides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      panoramaDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      currentPanoramaIndex = index;
    };

    const nextPanoramaSlide = () => {
      const nextIndex = (currentPanoramaIndex + 1) % panoramaSlides.length;
      showPanoramaSlide(nextIndex);
    };

    const prevPanoramaSlide = () => {
      const prevIndex = (currentPanoramaIndex - 1 + panoramaSlides.length) % panoramaSlides.length;
      showPanoramaSlide(prevIndex);
    };

    if (panoramaSlides.length > 1) {
      if (prevBtn) prevBtn.addEventListener('click', () => { prevPanoramaSlide(); resetPanoramaTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { nextPanoramaSlide(); resetPanoramaTimer(); });

      panoramaDots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          showPanoramaSlide(i);
          resetPanoramaTimer();
        });
      });

      const startPanoramaTimer = () => {
        if (autoRotate && !panoramaTimer) {
          panoramaTimer = setInterval(nextPanoramaSlide, speed);
        }
      };

      const stopPanoramaTimer = () => {
        if (panoramaTimer) {
          clearInterval(panoramaTimer);
          panoramaTimer = null;
        }
      };

      const resetPanoramaTimer = () => {
        stopPanoramaTimer();
        startPanoramaTimer();
      };

      startPanoramaTimer();

      panoramaBanner.addEventListener('mouseenter', stopPanoramaTimer);
      panoramaBanner.addEventListener('mouseleave', startPanoramaTimer);
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      const dotsWrap = panoramaBanner.querySelector('.panorama-slider-dots');
      if (dotsWrap) dotsWrap.style.display = 'none';
    }
  }

  // --- 0.25 Category Icons Slider Logic ---
  const categorySection = document.querySelector('.category-icons-section');
  if (categorySection && categorySection.dataset.layout === 'slider') {
    const wrap = categorySection.querySelector('.category-icons-wrap');
    const prevBtn = categorySection.querySelector('.category-slider-prev');
    const nextBtn = categorySection.querySelector('.category-slider-next');
    const autoRotate = categorySection.dataset.autoRotate === 'true';
    const speed = parseInt(categorySection.dataset.speed, 10) || 4000;

    let catTimer = null;

    const scrollAmount = () => {
      const card = categorySection.querySelector('.category-icon-card');
      return card ? card.offsetWidth + 20 : 200;
    };

    const scrollNext = () => {
      if (!wrap) return;
      const maxScroll = wrap.scrollWidth - wrap.clientWidth;
      if (wrap.scrollLeft >= maxScroll - 10) {
        wrap.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        wrap.scrollBy({ left: scrollAmount() * 2, behavior: 'smooth' });
      }
    };

    const scrollPrev = () => {
      if (!wrap) return;
      if (wrap.scrollLeft <= 10) {
        wrap.scrollTo({ left: wrap.scrollWidth, behavior: 'smooth' });
      } else {
        wrap.scrollBy({ left: -scrollAmount() * 2, behavior: 'smooth' });
      }
    };

    if (prevBtn) prevBtn.addEventListener('click', () => { scrollPrev(); resetCatTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { scrollNext(); resetCatTimer(); });

    const startCatTimer = () => {
      if (autoRotate && !catTimer) {
        catTimer = setInterval(scrollNext, speed);
      }
    };

    const stopCatTimer = () => {
      if (catTimer) {
        clearInterval(catTimer);
        catTimer = null;
      }
    };

    const resetCatTimer = () => {
      stopCatTimer();
      startCatTimer();
    };

    startCatTimer();

    if (wrap) {
      wrap.addEventListener('mouseenter', stopCatTimer);
      wrap.addEventListener('mouseleave', startCatTimer);
      wrap.addEventListener('touchstart', stopCatTimer, { passive: true });
      wrap.addEventListener('touchend', startCatTimer, { passive: true });
    }
  }

  // --- 0.3 Testimonials Auto-Slider ---
  const testimonialsSection = document.querySelector('.testimonials-section');
  if (testimonialsSection) {
    const testimonialSlides = testimonialsSection.querySelectorAll('.testimonial-slide');
    const testimonialDots = testimonialsSection.querySelectorAll('.testimonials-slider-dots .dot');
    const prevBtn = testimonialsSection.querySelector('.testimonials-slider-prev');
    const nextBtn = testimonialsSection.querySelector('.testimonials-slider-next');
    const autoRotate = testimonialsSection.dataset.autoRotate === 'true';
    const speed = parseInt(testimonialsSection.dataset.speed, 10) || 5000;

    let currentTestimonialIndex = 0;
    let testimonialTimer = null;

    const showTestimonialSlide = (index) => {
      testimonialSlides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });
      testimonialDots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      currentTestimonialIndex = index;
    };

    const nextTestimonialSlide = () => {
      const nextIndex = (currentTestimonialIndex + 1) % testimonialSlides.length;
      showTestimonialSlide(nextIndex);
    };

    const prevTestimonialSlide = () => {
      const prevIndex = (currentTestimonialIndex - 1 + testimonialSlides.length) % testimonialSlides.length;
      showTestimonialSlide(prevIndex);
    };

    if (testimonialSlides.length > 1) {
      if (prevBtn) prevBtn.addEventListener('click', () => { prevTestimonialSlide(); resetTestimonialTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', () => { nextTestimonialSlide(); resetTestimonialTimer(); });

      testimonialDots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          showTestimonialSlide(i);
          resetTestimonialTimer();
        });
      });

      const startTestimonialTimer = () => {
        if (autoRotate && !testimonialTimer) {
          testimonialTimer = setInterval(nextTestimonialSlide, speed);
        }
      };

      const stopTestimonialTimer = () => {
        if (testimonialTimer) {
          clearInterval(testimonialTimer);
          testimonialTimer = null;
        }
      };

      const resetTestimonialTimer = () => {
        stopTestimonialTimer();
        startTestimonialTimer();
      };

      startTestimonialTimer();

      testimonialsSection.addEventListener('mouseenter', stopTestimonialTimer);
      testimonialsSection.addEventListener('mouseleave', startTestimonialTimer);
    } else {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      const dotsWrap = testimonialsSection.querySelector('.testimonials-slider-dots');
      if (dotsWrap) dotsWrap.style.display = 'none';
    }
  }

  // --- 1. Featured Products Tab Filter ---
  const tabButtons = document.querySelectorAll('.featured-tabs-nav .tab-btn');
  const productItems = document.querySelectorAll('.featured-products-grid .product-grid-item');

  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      tabButtons.forEach(b => {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');

      const filter = btn.getAttribute('data-filter');
      productItems.forEach(item => {
        const itemCat = item.getAttribute('data-category');
        if (filter === 'all' || itemCat === filter || (itemCat && itemCat.includes(filter))) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });

  // --- 2. Product Details: Variant Pill Picker ---
  const optionPills = document.querySelectorAll('.product-option-pills .option-pill');
  const variantInput = document.getElementById('SelectedVariantId');
  const productJsonEl = document.querySelector('script[id^="ProductJson-"]');

  if (productJsonEl && optionPills.length > 0) {
    try {
      const productData = JSON.parse(productJsonEl.textContent);

      optionPills.forEach(pill => {
        pill.addEventListener('click', () => {
          const parentGroup = pill.closest('.product-option-group');
          parentGroup.querySelectorAll('.option-pill').forEach(p => p.classList.remove('active'));
          pill.classList.add('active');

          // Collect currently selected options
          const selectedOptions = [];
          document.querySelectorAll('.product-options .product-option-group').forEach(group => {
            const activePill = group.querySelector('.option-pill.active');
            if (activePill) {
              selectedOptions.push(activePill.getAttribute('data-value'));
            }
          });

          // Match variant
          const matchedVariant = productData.variants.find(variant => {
            return selectedOptions.every((opt, idx) => variant.options[idx] === opt);
          });

          if (matchedVariant) {
            if (variantInput) variantInput.value = matchedVariant.id;

            // Update SKU
            const skuEl = document.getElementById('ProductSku');
            if (skuEl) skuEl.textContent = matchedVariant.sku || 'N/A';

            // Update Price
            const priceEl = document.getElementById('ProductPrice');
            if (priceEl) {
              const formattedPrice = `₹${(matchedVariant.price / 100).toFixed(2)}`;
              priceEl.innerHTML = `<span class="price-item price-regular font-bold">${formattedPrice}</span>`;
            }

            // Update Add to Cart Button State
            const atcBtn = document.getElementById('AddToCartBtn');
            const buyNowBtn = document.getElementById('BuyNowBtn');
            if (atcBtn) {
              if (matchedVariant.available) {
                atcBtn.disabled = false;
                atcBtn.innerHTML = `
                  <svg class="btn-icon btn-icon--cart" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="9" cy="21" r="1"></circle>
                    <circle cx="20" cy="21" r="1"></circle>
                    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                  </svg>
                  <span class="btn-text">Add to Cart</span>
                `;
                if (buyNowBtn) buyNowBtn.disabled = false;
              } else {
                atcBtn.disabled = true;
                atcBtn.innerHTML = '<span class="btn-text">Out of Stock</span>';
                if (buyNowBtn) buyNowBtn.disabled = true;
              }
            }

            // Update Image if variant has featured image
            if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
              const mainImg = document.getElementById('ProductMainImage');
              if (mainImg) mainImg.src = matchedVariant.featured_image.src;
            }
          }
        });
      });
    } catch (e) {
      console.warn('Product variant parser:', e);
    }
  }

  // --- 3. Product Gallery Thumbnail Switching ---
  const thumbBtns = document.querySelectorAll('.product-gallery__thumb-btn');
  const mainImg = document.getElementById('ProductMainImage');

  thumbBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      thumbBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const targetSrc = btn.getAttribute('data-target-src');
      if (mainImg && targetSrc) {
        mainImg.src = targetSrc;
      }
    });
  });

  // --- 4. Quantity Stepper & Buy Now ---
  const qtyMinus = document.querySelector('.qty-btn--minus');
  const qtyPlus = document.querySelector('.qty-btn--plus');
  const qtyInput = document.getElementById('Quantity');

  if (qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });

    qtyPlus.addEventListener('click', () => {
      let val = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = val + 1;
    });
  }

  const buyNowBtn = document.getElementById('BuyNowBtn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const variantInput = document.getElementById('SelectedVariantId');
      const qtyInputEl = document.getElementById('Quantity');
      const variantId = variantInput ? variantInput.value : '';
      const qty = qtyInputEl ? (parseInt(qtyInputEl.value, 10) || 1) : 1;
      if (variantId) {
        window.location.href = `/cart/${variantId}:${qty}`;
      }
    });
  }

  // --- 5. Product Page Tabs ---
  const tabNavs = document.querySelectorAll('.product-tab-nav');
  const tabPanes = document.querySelectorAll('.product-tab-pane');

  tabNavs.forEach(nav => {
    nav.addEventListener('click', () => {
      tabNavs.forEach(n => {
        n.classList.remove('active');
        n.setAttribute('aria-selected', 'false');
      });
      tabPanes.forEach(p => p.classList.remove('active'));

      nav.classList.add('active');
      nav.setAttribute('aria-selected', 'true');
      const targetId = nav.getAttribute('data-tab-target');
      const targetPane = document.querySelector(targetId);
      if (targetPane) targetPane.classList.add('active');
    });
  });

  // --- 6. Collection Price Slider Sync ---
  const rangeMin = document.querySelector('.range-min');
  const rangeMax = document.querySelector('.range-max');
  const inputMin = document.getElementById('price-min');
  const inputMax = document.getElementById('price-max');
  const priceDisplayText = document.querySelector('.price-display-text');

  if (rangeMin && rangeMax && inputMin && inputMax) {
    const updatePriceDisplay = () => {
      if (priceDisplayText) {
        priceDisplayText.textContent = `Price: ₹${rangeMin.value} — ₹${rangeMax.value}`;
      }
    };

    rangeMin.addEventListener('input', () => {
      inputMin.value = rangeMin.value;
      updatePriceDisplay();
    });

    rangeMax.addEventListener('input', () => {
      inputMax.value = rangeMax.value;
      updatePriceDisplay();
    });

    inputMin.addEventListener('change', () => {
      rangeMin.value = inputMin.value;
      updatePriceDisplay();
    });

    inputMax.addEventListener('change', () => {
      rangeMax.value = inputMax.value;
      updatePriceDisplay();
    });
  }

  // --- 7. Mobile Navbar Toggle ---
  const mobileToggle = document.querySelector('.site-navbar__mobile-toggle');
  const navMenu = document.querySelector('.site-navbar__menu');

  if (mobileToggle && navMenu) {
    mobileToggle.addEventListener('click', () => {
      navMenu.classList.toggle('active');
      mobileToggle.classList.toggle('active');
    });
  }

  // ==========================================================================
  // --- 8. Slide-out Cart Drawer Controller ---
  const cartDrawer = document.getElementById('CartDrawer');
  const cartDrawerOverlay = cartDrawer ? cartDrawer.querySelector('.cart-drawer__overlay') : null;
  const cartDrawerClose = cartDrawer ? cartDrawer.querySelector('.cart-drawer__close') : null;
  const cartTriggers = document.querySelectorAll('.site-header__action--cart, .js-cart-drawer-trigger, .collection-app-cart-btn, .mobile-bottom-nav__cart-btn');

  const formatMoney = (cents) => {
    if (cents === null || cents === undefined) return '₹0.00';
    if (typeof cents === 'string') {
      if (cents.includes('₹') || cents.includes('Rs.')) return cents;
      const num = parseFloat(cents.replace(/[^0-9.]/g, ''));
      if (isNaN(num) || num === 0) return '₹0.00';
      return `₹${num.toFixed(2)}`;
    }
    const num = Number(cents);
    if (isNaN(num) || num <= 0) return '₹0.00';
    return `₹${(num / 100).toFixed(2)}`;
  };

  const openCartDrawer = () => {
    if (cartDrawer) {
      cartDrawer.classList.add('active');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      refreshCartDrawer();
    }
  };
  window.openCartDrawer = openCartDrawer;

  const closeCartDrawer = () => {
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };
  window.closeCartDrawer = closeCartDrawer;

  if (cartTriggers.length > 0) {
    cartTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openCartDrawer();
      });
    });
  }

  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  const refreshCartDrawer = async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      // Update Header Badges & Subtotal
      document.querySelectorAll('.cart-count-badge, .cart-drawer__count').forEach(el => {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('.cart-total-price, .cart-drawer__total-price').forEach(el => {
        el.textContent = formatMoney(cart.total_price);
      });

      // Update Discount Row in Cart Drawer
      let discountRow = document.querySelector('.cart-drawer__discount-row');
      const footerContainerEl = document.querySelector('.cart-drawer__footer');
      if (cart.total_discount > 0) {
        if (!discountRow && footerContainerEl) {
          discountRow = document.createElement('div');
          discountRow.className = 'cart-drawer__discount-row';
          discountRow.style.cssText = 'display: flex; justify-content: space-between; margin-bottom: 0.35rem; font-size: 0.9rem; color: #16a34a; font-weight: 600;';
          const subtotalRow = footerContainerEl.querySelector('.cart-drawer__subtotal-row');
          if (subtotalRow) footerContainerEl.insertBefore(discountRow, subtotalRow);
        }
        if (discountRow) {
          discountRow.style.display = 'flex';
          discountRow.innerHTML = `<span>Discount:</span><span class="cart-drawer__discount-amount">- ${formatMoney(cart.total_discount)}</span>`;
        }
      } else if (discountRow) {
        discountRow.style.display = 'none';
      }

      // Update Free Shipping Bar
      const shippingBarEl = document.querySelector('.cart-drawer__shipping-bar');
      const freeShippingThreshold = shippingBarEl ? (parseInt(shippingBarEl.getAttribute('data-threshold'), 10) || 50000) : 50000;
      if (shippingBarEl) {
        if (cart.total_price >= freeShippingThreshold) {
          shippingBarEl.innerHTML = `
            <p class="shipping-bar-text shipping-bar-text--free">🎉 Congratulations! You have unlocked <strong>FREE Shipping</strong>!</p>
            <div class="shipping-bar-progress"><div class="shipping-bar-fill" style="width: 100%;"></div></div>
          `;
        } else {
          const remaining = freeShippingThreshold - cart.total_price;
          const pct = Math.min(100, Math.round((cart.total_price * 100) / freeShippingThreshold));
          shippingBarEl.innerHTML = `
            <p class="shipping-bar-text">Add <strong>${formatMoney(remaining)}</strong> more to unlock <strong>FREE Shipping</strong>!</p>
            <div class="shipping-bar-progress"><div class="shipping-bar-fill" style="width: ${pct}%;"></div></div>
          `;
        }
      }

      // Render Items
      const itemsContainer = document.querySelector('.cart-drawer__items');
      const footerContainer = document.querySelector('.cart-drawer__footer');

      if (itemsContainer) {
        if (cart.item_count === 0) {
          itemsContainer.innerHTML = `
            <div class="cart-drawer__empty">
              <div class="cart-drawer__empty-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5">
                  <circle cx="9" cy="21" r="1"></circle>
                  <circle cx="20" cy="21" r="1"></circle>
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                </svg>
              </div>
              <p>Your cart is empty</p>
              <a href="/collections/all" class="btn btn--primary btn--sm cart-drawer__start-shopping">Start Shopping</a>
            </div>
          `;
          if (footerContainer) footerContainer.classList.add('hidden');
        } else {
          if (footerContainer) footerContainer.classList.remove('hidden');

          let itemsHtml = '';
          cart.items.forEach(item => {
            const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
              ? `<span class="cart-drawer__item-variant">${item.variant_title}</span>`
              : '';

            itemsHtml += `
              <div class="cart-drawer__item" data-line-item-key="${item.key}">
                <div class="cart-drawer__item-img-wrap">
                  ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cart-drawer__item-img">` : ''}
                </div>
                <div class="cart-drawer__item-details">
                  <a href="${item.url}" class="cart-drawer__item-title">${item.product_title}</a>
                  ${variantTitle}
                  <div class="cart-drawer__item-price">${formatMoney(item.final_line_price)}</div>
                  <div class="cart-drawer__item-bottom">
                    <div class="cart-drawer__qty-wrap">
                      <button type="button" class="drawer-qty-btn drawer-qty-minus" data-key="${item.key}">&minus;</button>
                      <input type="number" class="drawer-qty-input" value="${item.quantity}" min="0" readonly>
                      <button type="button" class="drawer-qty-btn drawer-qty-plus" data-key="${item.key}">&plus;</button>
                    </div>
                    <button type="button" class="cart-drawer__remove-btn" data-key="${item.key}" title="Remove item">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            `;
          });
          itemsContainer.innerHTML = itemsHtml;
          bindCartDrawerItemEvents();
        }
      }
    } catch (err) {
      console.warn('Error refreshing cart drawer:', err);
    }
  };

  const bindCartDrawerItemEvents = () => {
    // Plus
    document.querySelectorAll('.drawer-qty-plus').forEach(btn => {
      btn.onclick = async () => {
        const key = btn.getAttribute('data-key');
        const input = btn.parentElement.querySelector('.drawer-qty-input');
        const currentQty = parseInt(input.value, 10) || 1;
        await changeCartQuantity(key, currentQty + 1);
      };
    });

    // Minus
    document.querySelectorAll('.drawer-qty-minus').forEach(btn => {
      btn.onclick = async () => {
        const key = btn.getAttribute('data-key');
        const input = btn.parentElement.querySelector('.drawer-qty-input');
        const currentQty = parseInt(input.value, 10) || 1;
        await changeCartQuantity(key, Math.max(0, currentQty - 1));
      };
    });

    // Remove
    document.querySelectorAll('.cart-drawer__remove-btn').forEach(btn => {
      btn.onclick = async () => {
        const key = btn.getAttribute('data-key');
        await changeCartQuantity(key, 0);
      };
    });
  };

  const changeCartQuantity = async (key, quantity) => {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      await refreshCartDrawer();
    } catch (err) {
      console.error('Cart quantity update error:', err);
    }
  };

  // --- AJAX Add to Cart (Global Interceptor for Product Cards and Forms) ---
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (form && form.action && form.action.includes('/cart/add')) {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      const originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (res.ok) {
          if (submitBtn) submitBtn.textContent = 'Added!';
          setTimeout(() => {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalText;
            }
          }, 1200);

          // Close quick view if open, and open cart drawer
          closeQuickViewModal();
          openCartDrawer();
        } else {
          const errData = await res.json();
          alert(errData.description || 'Could not add product to cart.');
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }
        }
      } catch (err) {
        console.error('AJAX add to cart failed:', err);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      }
    }
  });

  // ==========================================================================
  // --- 9. Quick View Popup Modal Controller ---
  // ==========================================================================
  const getQuickViewModal = () => document.getElementById('QuickViewModal');

  const closeQuickViewModal = () => {
    const modal = getQuickViewModal();
    if (modal) {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('.quick-view-modal__close') || e.target.classList.contains('quick-view-modal__overlay')) {
      closeQuickViewModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeQuickViewModal();
    }
  });

  // Quick View & Select Options Button Click Handler
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__quick-view, .product-card__btn-select-options, .product-card__quick-view-action');
    if (btn) {
      e.preventDefault();

      const productHandle = btn.getAttribute('data-product-handle');
      const productUrl = btn.getAttribute('data-product-url') || (productHandle ? `/products/${productHandle}` : '#');
      const card = btn.closest('.product-card');
      const modal = getQuickViewModal();

      if (!modal) {
        if (productUrl && productUrl !== '#') window.location.href = productUrl;
        return;
      }

      modal.classList.add('active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      const quickViewLoading = modal.querySelector('.quick-view-modal__loading');
      const quickViewBody = modal.querySelector('.quick-view-modal__body');

      if (quickViewLoading) quickViewLoading.style.display = 'block';
      if (quickViewBody) quickViewBody.style.display = 'none';

      // 1. Try Instant Embedded JSON from card
      let productData = null;
      if (card) {
        const jsonScript = card.querySelector('.product-card-json');
        if (jsonScript && jsonScript.textContent) {
          try {
            productData = JSON.parse(jsonScript.textContent);
          } catch (jsonErr) {
            console.warn('JSON parse error from card:', jsonErr);
          }
        }
      }

      if (productData) {
        renderQuickViewProduct(productData, productUrl);
        return;
      }

      // 2. Fallback to AJAX Fetch
      if (productHandle) {
        try {
          const res = await fetch(`/products/${encodeURIComponent(productHandle)}.js`);
          if (res.ok) {
            const product = await res.json();
            renderQuickViewProduct(product, productUrl);
          } else {
            throw new Error('Product fetch failed');
          }
        } catch (err) {
          console.error('Quick view fetch error:', err);
          if (productUrl && productUrl !== '#') {
            window.location.href = productUrl;
          }
        }
      } else if (productUrl && productUrl !== '#') {
        window.location.href = productUrl;
      }
    }
  });

  const renderQuickViewProduct = (product, productUrl) => {
    const modal = getQuickViewModal();
    if (!modal) return;

    const quickViewLoading = modal.querySelector('.quick-view-modal__loading');
    const quickViewBody = modal.querySelector('.quick-view-modal__body');

    try {
      // 1. Title & Full Details Link
      const titleEl = document.getElementById('QuickViewTitle');
      if (titleEl) titleEl.textContent = product.title || '';

      const fullLinkEl = document.getElementById('QuickViewFullLink');
      if (fullLinkEl) fullLinkEl.href = productUrl || product.url || `/products/${product.handle || ''}`;

      // 2. Images & Gallery
      const mainImgEl = document.getElementById('QuickViewMainImage');
      const thumbsContainer = document.getElementById('QuickViewThumbs');

      let featuredSrc = '';
      if (typeof product.featured_image === 'string') {
        featuredSrc = product.featured_image;
      } else if (product.featured_image && product.featured_image.src) {
        featuredSrc = product.featured_image.src;
      } else if (product.images && product.images.length > 0) {
        featuredSrc = typeof product.images[0] === 'string' ? product.images[0] : (product.images[0].src || '');
      }

      if (mainImgEl && featuredSrc) {
        mainImgEl.src = featuredSrc;
        mainImgEl.alt = product.title || '';
      }

      if (thumbsContainer) {
        const imgList = (product.images || []).map(img => typeof img === 'string' ? img : (img.src || ''));
        if (imgList.length > 1) {
          let thumbsHtml = '';
          imgList.forEach((imgSrc, idx) => {
            thumbsHtml += `
              <button type="button" class="quick-view__thumb-btn ${idx === 0 ? 'active' : ''}" data-src="${imgSrc}">
                <img src="${imgSrc}" alt="${product.title || ''}">
              </button>
            `;
          });
          thumbsContainer.innerHTML = thumbsHtml;
          thumbsContainer.style.display = 'flex';

          thumbsContainer.querySelectorAll('.quick-view__thumb-btn').forEach(tb => {
            tb.onclick = () => {
              thumbsContainer.querySelectorAll('.quick-view__thumb-btn').forEach(t => t.classList.remove('active'));
              tb.classList.add('active');
              if (mainImgEl) mainImgEl.src = tb.getAttribute('data-src');
            };
          });
        } else {
          thumbsContainer.style.display = 'none';
        }
      }

      // 3. Price, Availability & Action Buttons
      const priceEl = document.getElementById('QuickViewPrice');
      const stockEl = document.getElementById('QuickViewAvailability');
      const variantIdInput = document.getElementById('QuickViewVariantId');
      const atcBtn = document.getElementById('QuickViewAddToCartBtn');
      const qvBuyNowBtn = document.getElementById('QuickViewBuyNowBtn');
      const qInput = document.getElementById('QuickViewQuantity');
      if (qInput) qInput.value = 1;

      const variants = product.variants || [];
      let currentVariant = variants[0] || {};

      const updateVariantView = (variant) => {
        currentVariant = variant;
        if (variantIdInput && variant.id) variantIdInput.value = variant.id;

        if (priceEl && variant.price !== undefined) {
          const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
          priceEl.innerHTML = `
            <span>${formatMoney(variant.price)}</span>
            ${hasDiscount ? `<s style="font-size: 1rem; color: #94a3b8; margin-left: 0.5rem;">${formatMoney(variant.compare_at_price)}</s>` : ''}
          `;
        }

        if (stockEl) {
          const isAvail = variant.available !== false;
          if (isAvail) {
            stockEl.innerHTML = '<span class="stock-dot in-stock"></span><span class="stock-text" style="color: #16a34a;">In Stock</span>';
          } else {
            stockEl.innerHTML = '<span class="stock-dot out-of-stock"></span><span class="stock-text" style="color: #ef4444;">Out of Stock</span>';
          }
        }

        if (atcBtn) {
          const isAvail = variant.available !== false;
          if (isAvail) {
            atcBtn.disabled = false;
            atcBtn.innerHTML = `
              <svg class="btn-icon btn-icon--cart" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="9" cy="21" r="1"></circle>
                <circle cx="20" cy="21" r="1"></circle>
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
              </svg>
              <span class="btn-text">Add to Cart</span>
            `;
            if (qvBuyNowBtn) qvBuyNowBtn.disabled = false;
          } else {
            atcBtn.disabled = true;
            atcBtn.innerHTML = '<span class="btn-text">Out of Stock</span>';
            if (qvBuyNowBtn) qvBuyNowBtn.disabled = true;
          }
        }

        if (variant.featured_image && variant.featured_image.src && mainImgEl) {
          mainImgEl.src = variant.featured_image.src;
        }
      };

      if (variants.length > 0) {
        updateVariantView(currentVariant);
      }

      // 4. Options & Variant Pills
      const optionsContainer = document.getElementById('QuickViewOptions');
      if (optionsContainer) {
        let normalizedOptions = [];
        if (product.options && product.options.length > 0) {
          if (typeof product.options[0] === 'string') {
            if (product.options[0] !== 'Title') {
              normalizedOptions = product.options.map((optName, idx) => {
                const optKey = `option${idx + 1}`;
                const values = Array.from(new Set(variants.map(v => (v.options ? v.options[idx] : v[optKey])).filter(Boolean)));
                return { name: optName, values: values };
              });
            }
          } else if (typeof product.options[0] === 'object' && product.options[0] !== null) {
            if (product.options[0].name !== 'Title') {
              normalizedOptions = product.options.map(opt => ({
                name: opt.name,
                values: opt.values || []
              }));
            }
          }
        }

        // Fallback: If product has multiple variants, always show variant pills
        if (normalizedOptions.length === 0 && variants.length > 1) {
          normalizedOptions = [{
            name: 'Select Variant / Weight',
            values: variants.map(v => v.title)
          }];
        }

        if (normalizedOptions.length > 0) {
          let optionsHtml = '';
          normalizedOptions.forEach((opt, optIdx) => {
            optionsHtml += `
              <div class="quick-view__option-group" data-option-index="${optIdx}">
                <label class="quick-view__option-label"><strong>${opt.name}:</strong></label>
                <div class="quick-view__option-pills">
                  ${opt.values.map((val, valIdx) => `
                    <button type="button" class="quick-view-pill ${valIdx === 0 ? 'active' : ''}" data-value="${val}" data-opt-idx="${optIdx}">
                      ${val}
                    </button>
                  `).join('')}
                </div>
              </div>
            `;
          });
          optionsContainer.innerHTML = optionsHtml;
          optionsContainer.style.display = 'block';

          // Bind Option Pill clicks
          optionsContainer.querySelectorAll('.quick-view-pill').forEach(pill => {
            pill.onclick = () => {
              const group = pill.closest('.quick-view__option-group');
              group.querySelectorAll('.quick-view-pill').forEach(p => p.classList.remove('active'));
              pill.classList.add('active');

              const val = pill.getAttribute('data-value');
              // Match variant
              const matched = variants.find(v => {
                return v.title === val ||
                  (v.options && v.options.includes(val)) ||
                  v.option1 === val || v.option2 === val || v.option3 === val;
              });

              if (matched) {
                updateVariantView(matched);
              }
            };
          });
        } else {
          optionsContainer.style.display = 'none';
        }
      }

      // 5. Quantity Stepper
      const qMinus = modal.querySelector('.quick-view-qty-minus');
      const qPlus = modal.querySelector('.quick-view-qty-plus');

      if (qMinus && qPlus && qInput) {
        qMinus.onclick = () => {
          let val = parseInt(qInput.value, 10) || 1;
          if (val > 1) qInput.value = val - 1;
        };
        qPlus.onclick = () => {
          let val = parseInt(qInput.value, 10) || 1;
          qInput.value = val + 1;
        };
      }

      // 6. Quick View Form AJAX Add To Cart
      const qvForm = document.getElementById('QuickViewForm');
      if (qvForm) {
        qvForm.onsubmit = async (e) => {
          e.preventDefault();
          const vInput = document.getElementById('QuickViewVariantId');
          const variantId = vInput ? vInput.value : '';
          const qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
          const atcButton = document.getElementById('QuickViewAddToCartBtn');
          if (!variantId) return;

          const originalContent = atcButton ? atcButton.innerHTML : '';
          if (atcButton) {
            atcButton.disabled = true;
            atcButton.innerHTML = '<span>Adding...</span>';
          }

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: qty })
            });
            if (res.ok) {
              closeQuickViewModal();
              await refreshCartDrawer();
              openCartDrawer();
            } else {
              const err = await res.json();
              alert(err.description || 'Could not add to cart');
            }
          } catch (err) {
            console.error('Error adding from quick view:', err);
          } finally {
            if (atcButton) {
              atcButton.disabled = false;
              atcButton.innerHTML = originalContent;
            }
          }
        };
      }

      // 7. Quick View Buy Now Button
      if (qvBuyNowBtn) {
        qvBuyNowBtn.onclick = (e) => {
          e.preventDefault();
          const vInput = document.getElementById('QuickViewVariantId');
          const variantId = vInput ? vInput.value : '';
          const qty = qInput ? (parseInt(qInput.value, 10) || 1) : 1;
          if (variantId) {
            window.location.href = `/cart/${variantId}:${qty}`;
          }
        };
      }
    } catch (renderErr) {
      console.error('Error rendering quick view product:', renderErr);
    } finally {
      // 8. ALWAYS Show Modal Body and Hide Loader
      if (quickViewLoading) quickViewLoading.style.display = 'none';
      if (quickViewBody) quickViewBody.style.display = 'grid';
    }
  };

  // --------------------------------------------------------------------------
  // Related Products Recommendations AJAX Loader
  // --------------------------------------------------------------------------
  const relatedSection = document.querySelector('.related-products-section[data-url]');
  if (relatedSection) {
    const url = relatedSection.getAttribute('data-url');
    if (url) {
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.related-products-grid');
          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            const currentGrid = relatedSection.querySelector('.related-products-grid');
            if (currentGrid) {
              currentGrid.innerHTML = recommendations.innerHTML;
              syncWishlistButtons();
            }
          }
        })
        .catch(e => console.error('Recommendations load error:', e));
    }
  }

  // ==========================================================================
  // Wishlist Engine (LocalStorage + Slide-Out Drawer + Header Sync)
  // ==========================================================================
  const WISHLIST_KEY = 'iyarkaikudil_wishlist';
  const wishlistDrawer = document.getElementById('WishlistDrawer');
  const wishlistItemsContainer = document.getElementById('WishlistDrawerItems');
  const wishlistEmptyState = wishlistDrawer ? wishlistDrawer.querySelector('.wishlist-drawer__empty') : null;
  const wishlistContentState = wishlistDrawer ? wishlistDrawer.querySelector('.wishlist-drawer__content') : null;
  const wishlistDrawerClose = wishlistDrawer ? wishlistDrawer.querySelector('.wishlist-drawer__close') : null;
  const wishlistDrawerOverlay = wishlistDrawer ? wishlistDrawer.querySelector('.wishlist-drawer__overlay') : null;
  const wishlistContinueBtn = wishlistDrawer ? wishlistDrawer.querySelector('.wishlist-drawer__continue-btn') : null;
  const wishlistClearBtn = wishlistDrawer ? wishlistDrawer.querySelector('.wishlist-drawer__clear-btn') : null;
  const headerWishlistTrigger = document.querySelector('.site-header__action--wishlist');

  const getWishlist = () => {
    try {
      const stored = localStorage.getItem(WISHLIST_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.warn('Could not read wishlist from localStorage:', e);
      return [];
    }
  };

  const saveWishlist = (list) => {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    } catch (e) {
      console.warn('Could not save wishlist to localStorage:', e);
    }
    updateWishlistUI();
  };

  const isInWishlist = (handle) => {
    const list = getWishlist();
    return list.some(item => item.handle === handle);
  };

  const toggleWishlistItem = (productData) => {
    if (!productData || !productData.handle) return;
    let list = getWishlist();
    const existingIndex = list.findIndex(item => item.handle === productData.handle);

    if (existingIndex > -1) {
      list.splice(existingIndex, 1);
    } else {
      list.push({
        id: productData.id || '',
        variantId: productData.variantId || (productData.variants && productData.variants[0] ? productData.variants[0].id : ''),
        handle: productData.handle,
        title: productData.title || '',
        price: productData.price || 0,
        compare_at_price: productData.compare_at_price || 0,
        image: productData.image || productData.featured_image || '',
        url: productData.url || `/products/${productData.handle}`,
        available: productData.available !== false
      });
    }

    saveWishlist(list);
  };

  const syncWishlistButtons = () => {
    const list = getWishlist();
    const handles = new Set(list.map(i => i.handle));

    // Update Product Card Heart Buttons
    document.querySelectorAll('.product-card__wishlist-btn').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      if (handles.has(handle)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });

    // Update Main Product Page Wishlist Button
    document.querySelectorAll('.btn-wishlist-action').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const label = btn.querySelector('.wishlist-btn-label');
      if (handles.has(handle)) {
        btn.classList.add('active');
        if (label) label.textContent = 'Added to Wishlist';
      } else {
        btn.classList.remove('active');
        if (label) label.textContent = 'Add to wishlist';
      }
    });
  };

  const updateWishlistUI = () => {
    const list = getWishlist();
    const count = list.length;

    // Self-heal: If any item in wishlist has 0 or missing price, fetch fresh product info in background
    list.forEach(item => {
      if ((!item.price || item.price === 0) && item.handle) {
        fetch(`/products/${encodeURIComponent(item.handle)}.js`)
          .then(r => r.ok ? r.json() : null)
          .then(data => {
            if (data && data.price) {
              item.price = data.price;
              item.compare_at_price = data.compare_at_price || 0;
              if (!item.variantId && data.variants && data.variants[0]) {
                item.variantId = data.variants[0].id;
              }
              saveWishlist(list);
            }
          })
          .catch(() => {});
      }
    });

    // Update count badges
    document.querySelectorAll('.wishlist-count-badge, .wishlist-drawer-count').forEach(badge => {
      badge.textContent = count;
    });

    // Update heart icons across the page
    syncWishlistButtons();

    // Render Drawer Content
    if (!wishlistItemsContainer) return;

    if (count === 0) {
      if (wishlistEmptyState) wishlistEmptyState.style.display = 'flex';
      if (wishlistContentState) wishlistContentState.style.display = 'none';
      wishlistItemsContainer.innerHTML = '';
      return;
    }

    if (wishlistEmptyState) wishlistEmptyState.style.display = 'none';
    if (wishlistContentState) wishlistContentState.style.display = 'flex';

    let html = '';
    list.forEach(item => {
      let imgSrc = typeof item.image === 'string' ? item.image : (item.image && item.image.src ? item.image.src : '');
      const priceFormatted = formatMoney(item.price);
      html += `
        <div class="wishlist-item" data-handle="${item.handle}">
          <div class="wishlist-item__img-wrap">
            ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" class="wishlist-item__img">` : ''}
          </div>
          <div class="wishlist-item__details">
            <h4 class="wishlist-item__title"><a href="${item.url}">${item.title}</a></h4>
            <div class="wishlist-item__price">${priceFormatted}</div>
            <div class="wishlist-item__actions">
              ${item.variantId ? `<button type="button" class="wishlist-item__btn-atc" data-variant-id="${item.variantId}">Add to Cart</button>` : ''}
              <button type="button" class="wishlist-item__btn-remove" data-handle="${item.handle}">Remove</button>
            </div>
          </div>
        </div>
      `;
    });

    wishlistItemsContainer.innerHTML = html;

    // Bind Add to Cart from Wishlist
    wishlistItemsContainer.querySelectorAll('.wishlist-item__btn-atc').forEach(btn => {
      btn.onclick = async () => {
        const variantId = btn.getAttribute('data-variant-id');
        if (variantId) {
          btn.textContent = 'Adding...';
          btn.disabled = true;
          try {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });
            await refreshCartDrawer();
            closeWishlistDrawer();
            openCartDrawer();
          } catch (e) {
            console.error('Wishlist ATC error:', e);
          } finally {
            btn.textContent = 'Add to Cart';
            btn.disabled = false;
          }
        }
      };
    });

    // Bind Remove from Wishlist
    wishlistItemsContainer.querySelectorAll('.wishlist-item__btn-remove').forEach(btn => {
      btn.onclick = () => {
        const handle = btn.getAttribute('data-handle');
        let currentList = getWishlist().filter(i => i.handle !== handle);
        saveWishlist(currentList);
      };
    });

    // ------------------------------------------------------------------------
    // Render Dedicated Wishlist Page (if on /pages/wishlist)
    // ------------------------------------------------------------------------
    const pageGrid = document.getElementById('WishlistPageGrid');
    const pageEmpty = document.getElementById('WishlistPageEmpty');
    const pageActionBar = document.getElementById('WishlistActionBar');
    const pageCountBadges = document.querySelectorAll('.wishlist-page-count');

    pageCountBadges.forEach(badge => {
      badge.textContent = count;
    });

    if (pageGrid && pageEmpty) {
      if (count === 0) {
        pageGrid.style.display = 'none';
        pageGrid.innerHTML = '';
        pageEmpty.style.display = 'flex';
        if (pageActionBar) pageActionBar.style.display = 'none';
      } else {
        pageEmpty.style.display = 'none';
        pageGrid.style.display = 'grid';
        if (pageActionBar) pageActionBar.style.display = 'flex';

        let gridHtml = '';
        list.forEach(item => {
          let imgSrc = typeof item.image === 'string' ? item.image : (item.image && item.image.src ? item.image.src : '');
          const priceFormatted = formatMoney(item.price);
          gridHtml += `
            <div class="wishlist-card" data-handle="${item.handle}">
              <div class="wishlist-card__image-wrap">
                ${imgSrc ? `<img src="${imgSrc}" alt="${item.title}" class="wishlist-card__image">` : ''}
                <button type="button" class="wishlist-card__remove-btn" data-handle="${item.handle}" aria-label="Remove item">&times;</button>
              </div>
              <div class="wishlist-card__info">
                <h3 class="wishlist-card__title"><a href="${item.url}">${item.title}</a></h3>
                <div class="wishlist-card__rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                  <span class="wishlist-card__rating-count">(${Math.floor(Math.random() * 40) + 60})</span>
                </div>
                <div class="wishlist-card__price">${priceFormatted}</div>
                <div class="wishlist-card__stock">In Stock</div>
                ${item.variantId ? `
                  <button type="button" class="wishlist-card__btn-atc" data-variant-id="${item.variantId}">
                    <span>ADD TO CART</span>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                      <circle cx="9" cy="21" r="1"></circle>
                      <circle cx="20" cy="21" r="1"></circle>
                      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg>
                  </button>
                ` : ''}
              </div>
            </div>
          `;
        });
        pageGrid.innerHTML = gridHtml;

        // Bind Wishlist Page Add to Cart
        pageGrid.querySelectorAll('.wishlist-card__btn-atc').forEach(btn => {
          btn.onclick = async () => {
            const variantId = btn.getAttribute('data-variant-id');
            if (variantId) {
              const span = btn.querySelector('span');
              if (span) span.textContent = 'ADDING...';
              btn.disabled = true;
              try {
                await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({ id: variantId, quantity: 1 })
                });
                await refreshCartDrawer();
                openCartDrawer();
              } catch (e) {
                console.error('Wishlist page ATC error:', e);
              } finally {
                if (span) span.textContent = 'ADD TO CART';
                btn.disabled = false;
              }
            }
          };
        });

        // Bind Wishlist Page Remove
        pageGrid.querySelectorAll('.wishlist-card__remove-btn').forEach(btn => {
          btn.onclick = () => {
            const handle = btn.getAttribute('data-handle');
            let currentList = getWishlist().filter(i => i.handle !== handle);
            saveWishlist(currentList);
          };
        });
      }
    }
  };

  const openWishlistDrawer = () => {
    if (wishlistDrawer) {
      updateWishlistUI();
      wishlistDrawer.classList.add('active');
      wishlistDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  };

  const closeWishlistDrawer = () => {
    if (wishlistDrawer) {
      wishlistDrawer.classList.remove('active');
      wishlistDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  // Header Wishlist Click
  if (headerWishlistTrigger) {
    headerWishlistTrigger.addEventListener('click', (e) => {
      // If we are already on /pages/wishlist, navigate normally
      if (window.location.pathname.includes('/pages/wishlist')) {
        return;
      }
      e.preventDefault();
      openWishlistDrawer();
    });
  }

  // Close Wishlist Events
  if (wishlistDrawerClose) wishlistDrawerClose.addEventListener('click', closeWishlistDrawer);
  if (wishlistDrawerOverlay) wishlistDrawerOverlay.addEventListener('click', closeWishlistDrawer);
  if (wishlistContinueBtn) wishlistContinueBtn.addEventListener('click', closeWishlistDrawer);

  // Clear All Wishlist
  const handleClearWishlist = () => {
    if (confirm('Are you sure you want to clear your wishlist?')) {
      saveWishlist([]);
    }
  };

  if (wishlistClearBtn) wishlistClearBtn.addEventListener('click', handleClearWishlist);
  const pageClearBtnEl = document.getElementById('WishlistPageClearBtn');
  if (pageClearBtnEl) pageClearBtnEl.addEventListener('click', handleClearWishlist);

  // Move All To Cart Button Handler
  const moveAllBtn = document.getElementById('WishlistMoveAllBtn');
  if (moveAllBtn) {
    moveAllBtn.addEventListener('click', async () => {
      const list = getWishlist();
      const validItems = list.filter(item => item.variantId).map(item => ({
        id: item.variantId,
        quantity: 1
      }));

      if (validItems.length === 0) {
        alert('No items in wishlist to add to cart.');
        return;
      }

      const originalText = moveAllBtn.innerHTML;
      moveAllBtn.innerHTML = '<span>MOVING...</span>';
      moveAllBtn.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: validItems })
        });
        await refreshCartDrawer();
        openCartDrawer();
      } catch (err) {
        console.error('Error moving all to cart:', err);
      } finally {
        moveAllBtn.innerHTML = originalText;
        moveAllBtn.disabled = false;
      }
    });
  }

  // Delegated Wishlist Button Click on Product Cards & Product Page
  document.addEventListener('click', (e) => {
    // 1. Product Card Wishlist Button
    const cardBtn = e.target.closest('.product-card__wishlist-btn');
    if (cardBtn) {
      e.preventDefault();
      e.stopPropagation();
      const card = cardBtn.closest('.product-card');
      let prodData = null;
      if (card) {
        const jsonScript = card.querySelector('.product-card-json');
        if (jsonScript && jsonScript.textContent) {
          try {
            prodData = JSON.parse(jsonScript.textContent);
          } catch (err) {}
        }
      }

      if (!prodData) {
        const handle = cardBtn.getAttribute('data-product-handle');
        const titleEl = card ? card.querySelector('.product-card__title a') : null;
        const imgEl = card ? card.querySelector('.product-card__image') : null;
        const linkEl = card ? card.querySelector('.product-card__image-link') : null;
        const varInput = card ? card.querySelector('input[name="id"]') : null;
        const priceEl = card ? card.querySelector('.product-card__price') : null;
        let price = 0;
        if (priceEl) {
          const numMatch = priceEl.textContent.replace(/[^0-9.]/g, '');
          if (numMatch) price = Math.round(parseFloat(numMatch) * 100);
        }
        prodData = {
          handle: handle,
          title: titleEl ? titleEl.textContent.trim() : '',
          image: imgEl ? imgEl.src : '',
          url: linkEl ? linkEl.href : `/products/${handle}`,
          variantId: varInput ? varInput.value : '',
          price: price
        };
      }

      toggleWishlistItem(prodData);
      return;
    }

    // 2. Product Details Page Wishlist Button
    const mainBtn = e.target.closest('.btn-wishlist-action');
    if (mainBtn) {
      e.preventDefault();
      const handle = mainBtn.getAttribute('data-product-handle');
      const titleEl = document.querySelector('.product-info__title') || document.querySelector('.product-title');
      const imgEl = document.getElementById('ProductMainImage');
      const varInput = document.getElementById('SelectedVariantId') || document.querySelector('form[action*="/cart/add"] input[name="id"]');

      let productData = null;
      const productJsonEl = document.querySelector('script[id^="ProductJson-"]');
      if (productJsonEl && productJsonEl.textContent) {
        try {
          productData = JSON.parse(productJsonEl.textContent);
        } catch (err) {}
      }

      const selectedVariantId = varInput ? varInput.value : '';
      let currentVariant = null;
      if (productData && productData.variants) {
        currentVariant = productData.variants.find(v => String(v.id) === String(selectedVariantId)) || productData.variants[0];
      }

      let price = 0;
      if (currentVariant && currentVariant.price !== undefined) {
        price = currentVariant.price;
      } else if (productData && productData.price !== undefined) {
        price = productData.price;
      } else {
        const priceEl = document.getElementById('ProductPrice') || document.querySelector('.product-info__price');
        if (priceEl) {
          const numMatch = priceEl.textContent.replace(/[^0-9.]/g, '');
          if (numMatch) price = Math.round(parseFloat(numMatch) * 100);
        }
      }

      const prodData = {
        id: productData ? productData.id : mainBtn.getAttribute('data-product-id'),
        handle: handle,
        title: titleEl ? titleEl.textContent.trim() : (productData ? productData.title : ''),
        image: (currentVariant && currentVariant.featured_image && currentVariant.featured_image.src) ? currentVariant.featured_image.src : (imgEl ? imgEl.src : (productData && productData.featured_image ? productData.featured_image : '')),
        url: window.location.pathname,
        variantId: selectedVariantId || (currentVariant ? currentVariant.id : ''),
        price: price,
        compare_at_price: currentVariant ? currentVariant.compare_at_price : 0,
        available: currentVariant ? currentVariant.available : true
      };
      toggleWishlistItem(prodData);
      return;
    }
  });

  // Initial Sync on Page Load
  updateWishlistUI();

  // ==========================================================================
  // Collection Infinite Scroll / Auto-Loading Pagination
  // ==========================================================================
  const initCollectionInfiniteScroll = () => {
    const paginationContainer = document.getElementById('CollectionPagination');
    const productsGrid = document.querySelector('.collection-products-grid');
    const loader = document.getElementById('InfiniteScrollLoader');

    if (!paginationContainer || !productsGrid || !loader) return;

    // Add class to hide static pagination links
    paginationContainer.classList.add('infinite-scroll-active');

    let nextUrl = paginationContainer.getAttribute('data-next-url');
    let isLoading = false;

    if (!nextUrl) {
      loader.style.display = 'none';
      return;
    }

    const loadNextPage = async () => {
      if (isLoading || !nextUrl) return;
      isLoading = true;
      loader.style.display = 'flex';

      try {
        const response = await fetch(nextUrl);
        if (!response.ok) throw new Error('Network error loading collection page');
        const text = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, 'text/html');

        // Extract new products
        const newCols = doc.querySelectorAll('.collection-products-grid .collection-grid-col');
        newCols.forEach((col, index) => {
          col.classList.add('fade-in-card');
          col.style.animationDelay = `${index * 40}ms`;
          productsGrid.appendChild(col);
        });

        // Sync wishlist heart buttons on newly appended cards
        syncWishlistButtons();

        // Update toolbar results count if present
        const newCountEl = doc.querySelector('.collection-toolbar__count');
        const currentCountEl = document.querySelector('.collection-toolbar__count');
        if (newCountEl && currentCountEl) {
          currentCountEl.innerHTML = newCountEl.innerHTML;
        }

        // Check for next page URL in the fetched document
        const nextPagination = doc.getElementById('CollectionPagination');
        if (nextPagination) {
          nextUrl = nextPagination.getAttribute('data-next-url');
        } else {
          nextUrl = null;
        }

        if (!nextUrl) {
          loader.innerHTML = '<div class="infinite-scroll-end">You have viewed all products in this collection.</div>';
          if (observer) observer.disconnect();
        }
      } catch (err) {
        console.error('Error auto-loading collection products:', err);
      } finally {
        isLoading = false;
      }
    };

    // Use IntersectionObserver with 350px bottom margin for instant seamless loading
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    }, {
      rootMargin: '0px 0px 350px 0px',
      threshold: 0.05
    });

    observer.observe(loader);
  };

  initCollectionInfiniteScroll();

  // ==========================================================================
  // Cart Page Interactive Steppers & Clear Cart
  // ==========================================================================
  const cartPageForm = document.getElementById('CartPageForm');
  if (cartPageForm) {
    // Stepper Buttons
    cartPageForm.querySelectorAll('.cart-page-qty-btn').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const key = btn.getAttribute('data-key');
        const input = cartPageForm.querySelector(`.cart-page-qty-input[data-key="${key}"]`);
        if (!input) return;

        let currentQty = parseInt(input.value, 10) || 0;
        if (btn.classList.contains('cart-qty-plus')) {
          currentQty += 1;
        } else if (btn.classList.contains('cart-qty-minus')) {
          currentQty = Math.max(0, currentQty - 1);
        }

        input.value = currentQty;

        // Auto update cart via AJAX
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: currentQty })
          });
          window.location.reload();
        } catch (err) {
          console.error('Cart change error:', err);
          cartPageForm.submit();
        }
      });
    });

    // Clear Cart Button
    const clearCartBtn = document.getElementById('ClearCartPageBtn');
    if (clearCartBtn) {
      clearCartBtn.addEventListener('click', async () => {
        if (confirm('Are you sure you want to clear your cart?')) {
          try {
            await fetch('/cart/clear.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
            });
            window.location.reload();
          } catch (err) {
            console.error('Cart clear error:', err);
          }
        }
      });
    }
  }

  // ==========================================================================
  // Collection Sidebar Price, Status & AJAX Category Filters
  // ==========================================================================
  const priceSlider = document.getElementById('PriceRangeSlider');
  const priceDisplayVal = document.getElementById('PriceDisplayVal');
  const applyPriceBtn = document.getElementById('ApplyPriceFilterBtn');
  const statusCheckboxes = document.querySelectorAll('input[name="filter_status"]');
  const noResultsEl = document.getElementById('NoFilterResults');
  const resetFiltersBtn = document.getElementById('ResetFiltersBtn');
  const productCountEl = document.getElementById('CollectionProductCount');

  const applyCollectionFilters = () => {
    if (!priceSlider) return;
    const maxPricePaise = parseInt(priceSlider.value, 10) * 100; // in paise
    const inStockCheckbox = document.querySelector('input[name="filter_status"][value="in_stock"]');
    const onSaleCheckbox = document.querySelector('input[name="filter_status"][value="on_sale"]');
    const inStockOnly = inStockCheckbox ? inStockCheckbox.checked : false;
    const onSaleOnly = onSaleCheckbox ? onSaleCheckbox.checked : false;

    const productCols = document.querySelectorAll('.collection-products-grid .collection-grid-col');
    let visibleCount = 0;

    productCols.forEach(col => {
      let price = parseInt(col.getAttribute('data-price'), 10);
      let available = col.getAttribute('data-available') === 'true';
      let comparePrice = parseInt(col.getAttribute('data-compare-price'), 10) || 0;

      // Fallback: parse from card if data attributes not present
      if (isNaN(price)) {
        const card = col.querySelector('.product-card');
        const script = card ? card.querySelector('.product-card-json') : null;
        if (script && script.textContent) {
          try {
            const pData = JSON.parse(script.textContent);
            price = pData.price_min || pData.price || 0;
            available = pData.available !== false;
            comparePrice = pData.compare_at_price || 0;
          } catch (e) {}
        }
      }

      let show = true;
      if (!isNaN(price) && price > maxPricePaise) {
        show = false;
      }
      if (inStockOnly && !available) {
        show = false;
      }
      if (onSaleOnly && (!comparePrice || comparePrice <= price)) {
        show = false;
      }

      if (show) {
        col.style.display = '';
        visibleCount++;
      } else {
        col.style.display = 'none';
      }
    });

    // Update Result Count
    if (productCountEl) {
      productCountEl.textContent = `Showing ${visibleCount} results`;
    }

    // Show/Hide No Results State
    if (noResultsEl) {
      noResultsEl.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  };

  if (priceSlider && priceDisplayVal) {
    priceSlider.addEventListener('input', () => {
      priceDisplayVal.textContent = `₹${parseInt(priceSlider.value, 10).toLocaleString('en-IN')}`;
      applyCollectionFilters();
    });

    if (applyPriceBtn) applyPriceBtn.addEventListener('click', applyCollectionFilters);
    priceSlider.addEventListener('change', applyCollectionFilters);

    statusCheckboxes.forEach(cb => {
      cb.addEventListener('change', applyCollectionFilters);
    });

    if (resetFiltersBtn) {
      resetFiltersBtn.addEventListener('click', () => {
        priceSlider.value = priceSlider.max || 2500;
        priceDisplayVal.textContent = `₹${parseInt(priceSlider.value, 10).toLocaleString('en-IN')}`;
        statusCheckboxes.forEach(cb => cb.checked = false);
        applyCollectionFilters();
      });
    }
  }

  // Instant Category Filter Navigation
  const categoryLinks = document.querySelectorAll('.sidebar-widget .filter-category-link');
  categoryLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetUrl = link.getAttribute('href');
      if (targetUrl && targetUrl !== '#') {
        window.location.href = targetUrl;
      }
    });
  });

  // ==========================================================================
  // App-Style Category Live Product Search Filter
  // ==========================================================================
  const collectionLiveSearch = document.getElementById('CollectionLiveSearch');
  const clearLiveSearchBtn = document.getElementById('ClearLiveSearchBtn');
  const collectionFeedCount = document.getElementById('CollectionFeedCount');

  if (collectionLiveSearch) {
    const handleCollectionSearch = () => {
      const query = collectionLiveSearch.value.trim().toLowerCase();
      if (clearLiveSearchBtn) {
        clearLiveSearchBtn.style.display = query.length > 0 ? 'block' : 'none';
      }

      const productCols = document.querySelectorAll('.collection-products-grid .collection-grid-col');
      let visible = 0;

      productCols.forEach(col => {
        const titleEl = col.querySelector('.product-card__title');
        const titleText = titleEl ? titleEl.textContent.trim().toLowerCase() : '';

        if (!query || titleText.includes(query)) {
          col.style.display = '';
          visible++;
        } else {
          col.style.display = 'none';
        }
      });

      if (collectionFeedCount) {
        collectionFeedCount.textContent = `${visible} items`;
      }
      if (productCountEl) {
        productCountEl.textContent = `Showing ${visible} results`;
      }
      if (noResultsEl) {
        noResultsEl.style.display = visible === 0 ? 'block' : 'none';
      }
    };

    collectionLiveSearch.addEventListener('input', handleCollectionSearch);

    if (clearLiveSearchBtn) {
      clearLiveSearchBtn.addEventListener('click', () => {
        collectionLiveSearch.value = '';
        handleCollectionSearch();
        collectionLiveSearch.focus();
      });
    }
  }

  // ==========================================================================
  // Live Predictive Quick Search Controller
  // ==========================================================================
  const searchInput = document.getElementById('LiveSearchInput');
  const searchResultsWrap = document.getElementById('LiveSearchResults');

  if (searchInput && searchResultsWrap) {
    const searchLoading = searchResultsWrap.querySelector('.live-search-loading');
    const searchList = searchResultsWrap.querySelector('.live-search-list');
    const searchFooter = searchResultsWrap.querySelector('.live-search-footer');
    const searchViewAll = searchResultsWrap.querySelector('.live-search-view-all');

    let debounceTimer = null;

    const performPredictiveSearch = async (query) => {
      if (!query || query.trim().length < 2) {
        searchResultsWrap.style.display = 'none';
        return;
      }

      const cleanQuery = query.trim();
      searchResultsWrap.style.display = 'block';
      if (searchLoading) searchLoading.style.display = 'flex';
      if (searchList) searchList.innerHTML = '';
      if (searchFooter) searchFooter.style.display = 'none';

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(cleanQuery)}&resources[type]=product&resources[limit]=6`);
        if (!response.ok) throw new Error('Search request failed');
        const data = await response.json();

        const products = (data && data.resources && data.resources.results && data.resources.results.products) ? data.resources.results.products : [];

        if (searchLoading) searchLoading.style.display = 'none';

        if (products.length === 0) {
          if (searchList) {
            searchList.innerHTML = `<div class="live-search-empty">No products found for "<strong>${cleanQuery}</strong>"</div>`;
          }
        } else {
          let html = '';
          products.forEach(prod => {
            const imgUrl = prod.image || (prod.featured_image ? prod.featured_image.url : '') || '';
            const price = prod.price ? `₹${parseFloat(prod.price).toLocaleString('en-IN', { minimumFractionDigits: 2 })}` : '';
            const badgeHtml = prod.available ? `<span class="live-search-item__badge">In Stock</span>` : `<span class="live-search-item__badge" style="background:#fee2e2;color:#b91c1c;">Out of Stock</span>`;

            html += `
              <a href="${prod.url}" class="live-search-item">
                <div class="live-search-item__img-wrap">
                  ${imgUrl ? `<img src="${imgUrl}" alt="${prod.title}" class="live-search-item__img" loading="lazy">` : `<svg width="24" height="24" fill="none" stroke="#94a3b8" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path></svg>`}
                </div>
                <div class="live-search-item__details">
                  <span class="live-search-item__title">${prod.title}</span>
                  <div class="live-search-item__price-row">
                    <span class="live-search-item__price">${price}</span>
                    ${badgeHtml}
                  </div>
                </div>
              </a>
            `;
          });

          if (searchList) searchList.innerHTML = html;

          if (searchFooter && searchViewAll) {
            searchViewAll.href = `/search?q=${encodeURIComponent(cleanQuery)}`;
            searchViewAll.textContent = `View all results for "${cleanQuery}" →`;
            searchFooter.style.display = 'block';
          }
        }
      } catch (err) {
        console.error('Predictive search error:', err);
        if (searchLoading) searchLoading.style.display = 'none';
        if (searchList) {
          searchList.innerHTML = `<div class="live-search-empty">Could not load results. Please press Enter to search.</div>`;
        }
      }
    };

    searchInput.addEventListener('input', (e) => {
      const q = e.target.value;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        performPredictiveSearch(q);
      }, 220);
    });

    searchInput.addEventListener('focus', () => {
      if (searchInput.value.trim().length >= 2) {
        searchResultsWrap.style.display = 'block';
      }
    });

    document.addEventListener('click', (e) => {
      if (!searchInput.contains(e.target) && !searchResultsWrap.contains(e.target)) {
        searchResultsWrap.style.display = 'none';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchResultsWrap.style.display = 'none';
      }
    });
  }


  // =========================================================================
  // 1. Pincode / Delivery Estimator Logic
  // =========================================================================
  const pincodeBox = document.getElementById('DeliveryEstimator');
  if (pincodeBox) {
    const pinInput = document.getElementById('PincodeInput');
    const checkBtn = document.getElementById('CheckPincodeBtn');
    const resultBox = document.getElementById('PincodeResult');
    const locationEl = document.getElementById('PincodeLocation');
    const dateEl = document.getElementById('PincodeDate');
    const codEl = document.getElementById('PincodeCod');

    const getEstimatedDeliveryDate = (daysToAdd) => {
      const targetDate = new Date();
      let added = 0;
      while (added < daysToAdd) {
        targetDate.setDate(targetDate.getDate() + 1);
        const dayOfWeek = targetDate.getDay();
        if (dayOfWeek !== 0) { // Skip Sundays
          added++;
        }
      }
      const options = { weekday: 'long', day: 'numeric', month: 'short' };
      return targetDate.toLocaleDateString('en-IN', options);
    };

    const evaluatePincode = (pincode) => {
      const pin = parseInt(pincode, 10);
      if (isNaN(pin) || pincode.length !== 6) {
        alert('Please enter a valid 6-digit Pincode');
        return;
      }

      const prefix2 = parseInt(pincode.substring(0, 2), 10);
      let location = 'India';
      let days = 4;
      let codAvailable = true;

      if (prefix2 >= 60 && prefix2 <= 64) {
        location = 'Tamil Nadu & Pondicherry';
        days = 2;
        codAvailable = true;
      } else if (prefix2 >= 67 && prefix2 <= 69) {
        location = 'Kerala';
        days = 3;
        codAvailable = true;
      } else if (prefix2 >= 56 && prefix2 <= 59) {
        location = 'Karnataka (Bangalore Zone)';
        days = 3;
        codAvailable = true;
      } else if (prefix2 >= 50 && prefix2 <= 53) {
        location = 'Andhra Pradesh & Telangana';
        days = 3;
        codAvailable = true;
      } else if (prefix2 >= 40 && prefix2 <= 44) {
        location = 'Maharashtra & Goa';
        days = 4;
        codAvailable = true;
      } else if (prefix2 >= 11 && prefix2 <= 13) {
        location = 'Delhi NCR & North India';
        days = 4;
        codAvailable = true;
      } else {
        location = 'Rest of India';
        days = 5;
        codAvailable = true;
      }

      if (locationEl) locationEl.textContent = location;
      if (dateEl) dateEl.textContent = getEstimatedDeliveryDate(days);
      if (codEl) {
        codEl.innerHTML = codAvailable
          ? `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg> Cash on Delivery Available`
          : `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg> Prepaid Express Delivery`;
      }

      if (resultBox) resultBox.style.display = 'block';
      localStorage.setItem('iyarkai_pincode', pincode);
    };

    if (checkBtn && pinInput) {
      checkBtn.addEventListener('click', () => {
        evaluatePincode(pinInput.value.trim());
      });

      pinInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          evaluatePincode(pinInput.value.trim());
        }
      });

      // Auto-populate from cache
      const cachedPin = localStorage.getItem('iyarkai_pincode');
      if (cachedPin && cachedPin.length === 6) {
        pinInput.value = cachedPin;
        evaluatePincode(cachedPin);
      }
    }
  }

  // =========================================================================
  // 3. Frequently Bought Together Bundle Builder Logic
  // =========================================================================
  const bundleWrap = document.getElementById('ProductBundleBuilder');
  if (bundleWrap) {
    const checkboxes = bundleWrap.querySelectorAll('.bundle-check');
    const mainItem = bundleWrap.querySelector('.bundle-item--main');
    const totalPriceEl = document.getElementById('BundleTotalPrice');
    const addBundleBtn = document.getElementById('AddBundleToCartBtn');

    const calculateBundleTotal = () => {
      let totalCents = 0;
      if (mainItem) {
        totalCents += parseInt(mainItem.dataset.price || 0, 10);
      }
      checkboxes.forEach(cb => {
        if (cb.checked) {
          totalCents += parseInt(cb.dataset.price || 0, 10);
        }
      });

      const discountPercent = parseFloat(bundleWrap.dataset.discountPercent || 5);
      const discountFactor = Math.max(0, (100 - discountPercent) / 100);
      const discountedTotal = totalCents * discountFactor;
      const formatted = `₹${(discountedTotal / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
      if (totalPriceEl) totalPriceEl.textContent = formatted;
    };

    checkboxes.forEach(cb => {
      cb.addEventListener('change', calculateBundleTotal);
    });

    calculateBundleTotal();

    if (addBundleBtn) {
      addBundleBtn.addEventListener('click', async () => {
        const items = [];
        if (mainItem && mainItem.dataset.id) {
          items.push({ id: parseInt(mainItem.dataset.id, 10), quantity: 1 });
        }
        checkboxes.forEach(cb => {
          if (cb.checked && cb.dataset.id) {
            items.push({ id: parseInt(cb.dataset.id, 10), quantity: 1 });
          }
        });

        if (items.length === 0) return;

        addBundleBtn.disabled = true;
        addBundleBtn.textContent = 'Adding Combo...';

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (res.ok) {
            if (window.openCartDrawer) {
              window.openCartDrawer();
            } else {
              const cartDrawer = document.getElementById('CartDrawer');
              if (cartDrawer) {
                cartDrawer.classList.add('active');
                document.body.classList.add('drawer-open');
              } else {
                window.location.href = '/cart';
              }
            }
          }
        } catch (err) {
          console.error('Bundle add error:', err);
        } finally {
          addBundleBtn.disabled = false;
          addBundleBtn.innerHTML = `
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="9" cy="21" r="1"></circle>
              <circle cx="20" cy="21" r="1"></circle>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
            </svg>
            <span>Add Combo to Cart</span>
          `;
        }
      });
    }
  }

  // =========================================================================
  // 4. Sticky Add to Cart Bar Logic
  // =========================================================================
  const stickyBar = document.getElementById('StickyCartBar');
  const mainAddToCartBtn = document.getElementById('AddToCartBtn');

  if (stickyBar && mainAddToCartBtn) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        // Show sticky bar when main Add to Cart button scrolls out of view
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(mainAddToCartBtn);

    const stickySelect = document.getElementById('StickyVariantSelect');
    const stickyPrice = document.getElementById('StickyCartPrice');
    const stickyAddBtn = document.getElementById('StickyAddToCartBtn');

    if (stickySelect) {
      stickySelect.addEventListener('change', (e) => {
        const selectedOpt = stickySelect.options[stickySelect.selectedIndex];
        if (selectedOpt && selectedOpt.dataset.price && stickyPrice) {
          stickyPrice.textContent = selectedOpt.dataset.price;
        }
      });
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', () => {
        const variantId = stickySelect ? stickySelect.value : (document.getElementById('SelectedVariantId')?.value);
        if (!variantId) {
          if (mainAddToCartBtn) mainAddToCartBtn.click();
          return;
        }

        stickyAddBtn.disabled = true;
        const originalText = stickyAddBtn.innerHTML;
        stickyAddBtn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(r => r.json())
        .then(() => {
          if (window.openCartDrawer) {
            window.openCartDrawer();
          } else {
            const cartDrawer = document.getElementById('CartDrawer');
            if (cartDrawer) {
              cartDrawer.classList.add('active');
              document.body.classList.add('drawer-open');
            } else {
              window.location.href = '/cart';
            }
          }
        })
        .catch(err => console.error(err))
        .finally(() => {
          stickyAddBtn.disabled = false;
          stickyAddBtn.innerHTML = originalText;
        });
      });
    }
  }

});



